import { useState } from 'react'

import Modal from '@components/Modal'
import AccountForm from 'dashboard-account/components/AccountForm'

import Button from '@components/Button'
import { withTranslate } from '@i18n/utils'
import { formatAddress, isAddressFilled } from 'shared/utils'
import ErrorMessage from '@components/ErrorMessage'

const AddressSectionComponent = ({ billingAddress, deliveryAddress, translate: t }) => {
    const [open, setOpen] = useState(false)

    const closeModal = () => {
        const modals = document.getElementsByClassName('modal-dropdown')
        if (modals.length === 1) {
            setOpen(false)
        }
    }

    return (
        <>
            <h5 className="mb-3 mt-6">
                <T>{`subscription.purchase.label.billing`}</T>
            </h5>
            <div>
                {isAddressFilled(billingAddress) ? (
                    formatAddress(billingAddress)
                ) : (
                    <ErrorMessage messages={[t('subscription.purchase.label.billing.error')]} type="text" />
                )}
            </div>
            <h5 className="mb-3 mt-4">
                <T>{`subscription.purchase.label.delivery`}</T>
            </h5>
            <div className="mb-4">
                {isAddressFilled(deliveryAddress) ? (
                    formatAddress(deliveryAddress)
                ) : (
                    <ErrorMessage messages={[t('subscription.purchase.label.billing.error')]} type="text" />
                )}
            </div>
            <Button size="small" btnStyle="link" iconLeft="plus-round" type="button" onClick={() => setOpen(true)}>
                <T>subscription.purchase.btn.edit.addresses</T>
            </Button>
            {open && (
                <Modal onClose={closeModal}>
                    <AccountForm hiddenUserDetails onSuccess={() => setOpen(false)} />
                </Modal>
            )}
        </>
    )
}

export default withTranslate(AddressSectionComponent)
